import type { DeliveryTypes } from '../FreightSimulation'
import type { FreightSimulationData } from '../useFreightSimulation'

export const getDeliveriesByType = (
  deliveryType: string,
  freightSimulationValue: FreightSimulationData | null
) => {
  if (!freightSimulationValue || !freightSimulationValue.packages) {
    return []
  }

  try {
    return freightSimulationValue.packages.reduce(
      (acc: DeliveryTypes, curr) => {
        const filteredTypes = curr.deliveryTypes.filter(
          (delivery) => delivery.type === deliveryType
        )

        return acc.concat(filteredTypes)
      },
      []
    )
  } catch (error) {
    console.error('Error getting deliveries by type:', error)

    return []
  }
}
